import React, {
  useMemo,
} from "react";
import { useAppSelector } from "../../api/hooks";
import {
  selectCards,
  type ICard,
} from "../../api/cardsSlice";
import { Card } from "../../components/card/card";
import "./cardsListPage.css";

const MINOR_SUITS = [
  "wands",
  "cups",
  "swords",
  "pentacles",
] as const;

type MinorSuit =
  (typeof MINOR_SUITS)[number];

const suitTitleRu:
  Record<
    MinorSuit,
    string
  > = {
    wands: "Жезлы",
    cups: "Кубки",
    swords: "Мечи",
    pentacles:
      "Пентакли",
  };

const sortMinor = (
  a: ICard,
  b: ICard
): number =>
  a.number - b.number;

export const CardsListPage:
  React.FC = () => {
    const {
      majorArcanes,
      minorArcanes,
    } =
      useAppSelector(
        selectCards
      );

    const minorBySuit =
      useMemo(() => {
        const groups:
          Record<
            MinorSuit,
            ICard[]
          > = {
            wands: [],
            cups: [],
            swords: [],
            pentacles: [],
          };

        minorArcanes.cards.forEach(
          (card) => {
            if (
              card.suit !==
              "major"
            ) {
              groups[
                card.suit
              ].push(card);
            }
          }
        );

        MINOR_SUITS.forEach(
          (suit) => {
            groups[suit] = [
              ...groups[
                suit
              ],
            ].sort(
              sortMinor
            );
          }
        );

        return groups;
      }, [
        minorArcanes.cards,
      ]);

    const cardsCount =
      majorArcanes.cards
        .length +
      minorArcanes.cards
        .length;

    return (
      <div className="cards-catalog">
        <header className="page-intro">
          <div className="page-intro__eyebrow">
            {
              cardsCount
            } карт
          </div>

          <h1 className="page-intro__title">
            Карты Таро
          </h1>

          <p className="page-intro__text">
            Значения карт,
            символика, архетипы
            и материалы для
            интерпретации.
          </p>
        </header>

        <div className="cards-catalog__sections">
          <section className="cards-catalog__section">
            <h2 className="cards-catalog__title">
              {
                majorArcanes.title
              }
            </h2>

            <div className="cards-catalog__grid">
              {majorArcanes.cards.map(
                (card) => (
                  <Card
                    key={
                      card.id
                    }
                    card={
                      card
                    }
                  />
                )
              )}
            </div>
          </section>

          {MINOR_SUITS.map(
            (suit) => {
              const cards =
                minorBySuit[
                  suit
                ];

              if (
                cards.length ===
                0
              ) {
                return null;
              }

              return (
                <section
                  key={suit}
                  className="cards-catalog__section"
                >
                  <h2 className="cards-catalog__title">
                    {
                      minorArcanes.title
                    }{" "}
                    —{" "}
                    {
                      suitTitleRu[
                        suit
                      ]
                    }
                  </h2>

                  <div className="cards-catalog__grid">
                    {cards.map(
                      (
                        card
                      ) => (
                        <Card
                          key={
                            card.id
                          }
                          card={
                            card
                          }
                        />
                      )
                    )}
                  </div>
                </section>
              );
            }
          )}
        </div>
      </div>
    );
  };

